// extracted by mini-css-extract-plugin
export default {"container":"background-color-option-module__container--Ahkgh"};